export default __webpack_public_path__ + "assets/models/baf91c88b9151e5fe33207451ee90e1e.glb";